<template>
  <div class="hh-footer eh-footer-card">
    <span class="col-12">
      Copyright Autodesk, Inc {{currentYear}}
      <span class="d-none d-sm-inline">&nbsp;|&nbsp;</span>
      <div class="d-sm-inline text-center">
        Share your feedback on
        <a :href="employeeHubSlackUrl" target="_blank">
          <strong>Slack</strong>
        </a>
        or submit an
        <a :href="tellUsUrl" target="_blank">
          <strong>idea</strong>
        </a>
      </div>
    </span>
  </div>
</template>

<script>
import CONSTANTS from "@/store/constants";
export default {
  computed: {
    currentYear() {
      return new Date().getFullYear();
    }
  },
  data() {
    return {
      tellUsUrl: CONSTANTS.FOOTER_TELL_US_URL,
      employeeHubSlackUrl: CONSTANTS.EMPLOYEE_HUB_SLACK_URL,
      
    };
  }
};
</script>

<style scoped>
.eh-footer-card a {
  text-decoration: underline !important;
}
</style>


